export const declensions = {
  residents: ['житель', 'жильца', 'жильцов'],
  registeredResidents: [
    'зарегистрированный житель',
    'зарегистрированных жильца',
    'зарегистрированных жильцов',
  ],
  aliveResidents: [
    'житель с мобильным приложением',
    'жильца с мобильным приложением',
    'жильцов с мобильным приложением',
  ],
  owners: ['собственник', 'собственника', 'собственников'],
  flats: ['квартира', 'квартиры', 'квартир'],
  porchs: ['подъезд', 'подъезда', 'подъездов'],
  houses: ['дом', 'дома', 'домов'],
  room: ['помещение', 'помещения', 'помещений'],
  request: ['заявка', 'заявки', 'заявок'],
};
